import React, { useState, useEffect } from 'react';
import '../../../assests/css/customer/UploadScreen.css';
import MyNavbar from '../Mynavbar/MyNavbar';
import { useNavigate } from 'react-router-dom';
import CustomerFeedback, { FeedbackReviews } from '../../../screen/user/CustomerFeedback/CustomerFeedback';
import { useContext } from 'react';
import AppContext from '../../../context/AppContext';
import axios from 'axios';
import Swal from 'sweetalert2';

// ---- Trial limit settings: 2 try-on, phir 72 ghante (3 din) ka lock ----


// ---- Refresh (F5) ke baad upload/product/result gayab na ho isliye persist key ----
const PERSIST_KEY = 'tryOnState';

const loadPersistedState = () => {
  try {
    const raw = sessionStorage.getItem(PERSIST_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

const savePersistedState = (data) => {
  try {
    sessionStorage.setItem(PERSIST_KEY, JSON.stringify(data));
  } catch (err) {
    console.error('Try-on state save failed:', err);
  }
};

// ---- Common download helper (image URL -> device download) ----
const downloadImageFromUrl = async (imageUrl, filenamePrefix = 'image') => {
  if (!imageUrl) return false;
  try {
    const response = await fetch(imageUrl, { mode: 'cors' });
    const blob = await response.blob();
    const blobUrl = window.URL.createObjectURL(blob);

    const ext = blob.type.includes('png') ? 'png' : 'jpg';
    const a = document.createElement('a');
    a.href = blobUrl;
    a.download = `${filenamePrefix}_${Date.now()}.${ext}`;
    document.body.appendChild(a);
    a.click();
    a.remove();

    window.URL.revokeObjectURL(blobUrl);
    return true;
  } catch (err) {
    console.error('Download failed:', err);
    // Fallback: naya tab open kar do agar fetch/CORS block ho
    window.open(imageUrl, '_blank');
    return false;
  }
};

const UploadScreen = () => {
  const navigate = useNavigate();
  const { uploadImage, baseUrlForFiles, baseUrl } = useContext(AppContext);

  // ── FIX: page load par persisted state (agar hai) uthate hain,
  // taake refresh ke baad selected image / result / product gayab na ho.
  const persisted = loadPersistedState();

  const [selectedImage, setSelectedImage] = useState(persisted?.selectedImage || null);
  const [selectedFile, setSelectedFile] = useState(null); // File object persist nahi ho sakta
  const [selectedFileName, setSelectedFileName] = useState(persisted?.selectedFileName || '');
  const [resultImage, setResultImage] = useState(persisted?.resultImage || null);
  const [errorMsg, setErrorMsg] = useState(null);
  const [showResult, setShowResult] = useState(persisted?.showResult || false);
  const [isGenerating, setIsGenerating] = useState(false);
  const [hasGenerated, setHasGenerated] = useState(persisted?.hasGenerated || false);
  const [loading, setLoading] = useState(false);
  const [cancelBlink, setCancelBlink] = useState(false);
  const [showFeedback, setShowFeedback] = useState(false);
  const [feedbackRefreshKey, setFeedbackRefreshKey] = useState(0);

  const [trialBlocked, setTrialBlocked] = useState(false);
  const [trialWaitText, setTrialWaitText] = useState('');
  const [remainingTrials, setRemainingTrials] = useState(2);

  // ---- Save-to-account states ----
  const [isSaving, setIsSaving] = useState(false);
  const [isSaved, setIsSaved] = useState(persisted?.isSaved || false);

  const fallbackProductImage = 'https://images.unsplash.com/photo-1434389677669-e08b4cac3105?w=400&h=600&fit=crop';

  // ── FIX: helper jo har possible shape ko handle karta hai
  // (string path, object with image_path, already-full URL, ya "image" fallback field)
  const resolveImageUrl = (value) => {
    if (!value) return null;

    // Value khud ek string hai (path ya full URL)
    if (typeof value === 'string') {
      if (value.startsWith('http://') || value.startsWith('https://')) return value;
      return `${baseUrlForFiles}/${value}`;
    }

    // Value ek object hai jismein image_path ho sakta hai (ya path/url variants)
    if (typeof value === 'object') {
      const path = value.image_path || value.path || value.url || value.image;
      if (path) return resolveImageUrl(path);
    }

    return null;
  };

  // ── FIX: pehle images[0] try karo (kisi bhi field-naming ke saath),
  // phir uploadImage.image, phir uploadImage.image_path, phir persisted product,
  // phir fallback dummy. Isse refresh ke baad bhi product card gayab nahi hoti
  // (AppContext ka uploadImage refresh par reset ho sakta hai, isliye persisted
  // product info yahan backup ka kaam karti hai).
  const getUploadProductImage = () => {
    if (uploadImage) {
      if (Array.isArray(uploadImage.images) && uploadImage.images.length > 0) {
        const resolved = resolveImageUrl(uploadImage.images[0]);
        if (resolved) return resolved;
      }

      const directResolved =
        resolveImageUrl(uploadImage.image) || resolveImageUrl(uploadImage.image_path);
      if (directResolved) return directResolved;
    }

    if (persisted?.productImage) return persisted.productImage;

    return fallbackProductImage;
  };

  const productImage = getUploadProductImage();
  const productName = uploadImage?.name || persisted?.productName || 'Elegant Summer Dress';
  const productId = uploadImage?.id || persisted?.productId || null;

  useEffect(() => {
    const link = document.createElement('link');
    link.href = 'https://fonts.googleapis.com/css2?family=Bubblegum+Sans&display=swap';
    link.rel = 'stylesheet';
    document.head.appendChild(link);
    return () => {
      document.head.removeChild(link);
    };
  }, []);

  // Try-On generate hone k 1 second baad feedback popup khulta hy
  useEffect(() => {
    if (!showResult) return;
    const timer = setTimeout(() => {
      setShowFeedback(true);
    }, 1000);
    return () => clearTimeout(timer);
  }, [showResult]);

  // ── FIX: koi bhi relevant state change ho to sessionStorage mein
  // save kar do, taake F5 ke baad selected image, product, aur result
  // sab wapis mil jayein.
  useEffect(() => {
    savePersistedState({
      selectedImage,
      selectedFileName,
      resultImage,
      showResult,
      hasGenerated,
      isSaved,
      productImage,
      productName,
      productId,
    });
  }, [
    selectedImage,
    selectedFileName,
    resultImage,
    showResult,
    hasGenerated,
    isSaved,
    productImage,
    productName,
    productId,
  ]);

  // ---- Sirf 72 ghante k andar wale trials nikalta hy ----
  const fetchTrialStatus = async () => {
  const token = localStorage.getItem('authToken') || localStorage.getItem('token');
  if (!token) return;

  try {
    const res = await axios.get(`${baseUrl}/customer/tryOn/trial-status`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    if (res.data.success) {
      setRemainingTrials(res.data.remaining);
      setTrialBlocked(res.data.blocked);
      setTrialWaitText(res.data.wait_text || '');
    }
  } catch (err) {
    console.error('Trial status error:', err);
  }
};
  // Page load pr check karo, aur har minute update karo taky timer sahi dikhta rahy
 useEffect(() => {
  fetchTrialStatus();
}, []);

  // ---- Auth helper — Customization.jsx jaisa hi login check ----
  const isLoggedIn = () => {
    const token = localStorage.getItem('authToken') || localStorage.getItem('token');
    return Boolean(token);
  };

  // ---- Login page par bhejna, current selection state ke saath ----
  const redirectToLogin = () => {
    Swal.fire({
      icon: 'info',
      title: 'Login required',
      text: 'Try-on generate karne ke liye pehle login karein.',
      timer: 1800,
      showConfirmButton: false,
    });

    navigate('/login', {
      state: {
        from: '/upload',
        redirectTo: '/upload',
      },
    });
  };

  const handleFileSelect = (event) => {
    if (hasGenerated || trialBlocked) return;
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file);
      setSelectedFileName(file.name);
      const reader = new FileReader();
      reader.onload = (e) => {
        setSelectedImage(e.target.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleGenerateTryOn = async () => {
    if (!selectedFile || hasGenerated || !uploadImage) return;

    // ── LOGIN CHECK ── (Customization.jsx jaisa hi behavior)
    if (!isLoggedIn()) {
      redirectToLogin();
      return;
    }
    setIsGenerating(true);
    setLoading(true);
    setErrorMsg(null);
    setIsSaved(false);

    try {
      // ── FIX: productImage (jo ab robust resolve hoti hai) hi backend ko bhejo,
      // pehle wala code sirf images[0].image_path pe depend karta tha
      const dressImageUrl = productImage;

      const formData = new FormData();
      formData.append('person_image', selectedFile);
      formData.append('dress_image_url', dressImageUrl);

      // NOTE: pehle ye request "token" attach nahi kar rahi thi, isliye
      // backend 401 return karta tha aur aapka global interceptor
      // login page py bhej deta tha. Ab token localStorage se le kr
      // Authorization header mein bhej rahe hain.
      const token = localStorage.getItem('authToken') || localStorage.getItem('token');

      const response = await axios.post(`${baseUrl}/customer/tryOn`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
      });

      if (response.data.success) {
        setResultImage(`${baseUrlForFiles}/${response.data.data}`);
        setShowResult(true);
        setHasGenerated(true);
        fetchTrialStatus();
      } else {
        setErrorMsg(response.data.error || 'Try-on generate nahi ho saka.');
      }
    } catch (error) {
      if (error.response?.status === 401) {
        redirectToLogin();
        setIsGenerating(false);
        setLoading(false);
        return;
      }
if (error.response?.status === 429) {
    fetchTrialStatus(); 
  }

  setErrorMsg(error.response?.data?.error || 'Kuch ghalat ho gaya, dobara try karein.');
} finally {
      setIsGenerating(false);
      setLoading(false);
    }
  };

  // showResult k baad "Go Back" product-detail page py le jata hy,
  // us se pehle ye normal cancel/back ki tarha kaam karta hy
  const handleCancel = () => {
    setCancelBlink(true);
    setTimeout(() => {
      setCancelBlink(false);
      if (showResult) {
        navigate(`/product-detail/${productId}`);
      } else {
        navigate(-1);
      }
    }, 300);
  };

  // ---- Download result image to device ----
   const handleDownloadResult = async () => {
    if (!resultImage) return;

    const downloaded = await downloadImageFromUrl(
      resultImage,
      `tryon_${productName.replace(/\s+/g, '_')}`
    );

    if (downloaded) {
      Swal.fire({
        icon: 'success',
        title: 'Downloaded!',
        text: 'Image aapke device mein download ho gayi.',
        timer: 1800,
        showConfirmButton: false,
      });
    }
  };

  // ---- Save result to user's account (backend) ----
    const handleSaveResult = async () => {
    if (!resultImage || isSaving || isSaved) return;

    if (!isLoggedIn()) {
      redirectToLogin();
      return;
    }

    setIsSaving(true);

    try {
      const token = localStorage.getItem('authToken') || localStorage.getItem('token');

      const res = await axios.post(
        `${baseUrl}/customer/saved-designs`,
        {
          type: 'tryon',
          image_path: resultImage,
          title: productName,
          product_id: productId,
        },
        {
          headers: {
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
          },
        }
      );

      if (res.data.success) {
        setIsSaved(true);
        Swal.fire({
          icon: 'success',
          title: 'Saved!',
          text: 'Design aapke account mein save ho gaya.',
          timer: 1800,
          showConfirmButton: false,
        });
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Save failed',
          text: res.data.error || 'Save nahi ho saka.',
        });
      }
    } catch (error) {
      if (error.response?.status === 401) {
        redirectToLogin();
        return;
      }

      Swal.fire({
        icon: 'error',
        title: 'Save failed',
        text: error.response?.data?.error || 'Save karte waqt masla hua.',
      });
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="virtual-tryon">
      <MyNavbar />

      <div className="tryon-topbar">
        <button className={`back-btn ${cancelBlink ? 'cancel-blink' : ''}`} onClick={handleCancel}>
          ←
        </button>
        <div className="tryon-topbar-title">
          <h1>Back</h1>
          {/* <p className="step-text">{showResult ? 'Your Result' : 'Upload Your Picture'}</p> */}
        </div>
      </div>

      {/* 3-Panel Layout matching Moonlit try-on design */}
      <div className="main-content-3col">

        {/* LEFT: Upload/Capture */}
        <div className="upload-panel">
           <h2>Upload </h2>
          <p className="upload-subtitle">
            For the best AI results, please upload a clear full-body photo of yourself.
          </p>
          <button
            className="browse-file-btn"
            disabled={hasGenerated || trialBlocked}
            onClick={() => document.getElementById('file-input').click()}
          >
            <span className="browse-file-icon">⭱</span> Browse File
          </button>

          <input
            type="file"
            id="file-input"
            accept="image/jpeg,image/png,image/webp"
            onChange={handleFileSelect}
            disabled={hasGenerated || trialBlocked}
            style={{ display: 'none' }}
          />

          <div className={`upload-preview-box ${hasGenerated ? 'disabled' : ''}`}>
            {selectedImage ? (
              <>
                <img src={selectedImage} alt="Selected" className="upload-preview-img" />
                <p className="upload-file-name">{selectedFileName || 'selected_image.jpg'}</p>
                <p className="upload-status-text">✓ Upload Completed</p>
              </>
            ) : (
              <>
                <div className="upload-icon">☁️</div>
                <p className="preview-placeholder-text">Drag and drop your image here</p>
              </>
            )}
          </div>
          <p className="file-support">Supports: JPG, PNG, WEBP (Max 10MB)</p>

          {trialBlocked && (
            <p className="trial-limit-text">⏳ {trialWaitText}</p>
          )}
        </div>

        {/* CENTER: Selected Product */}
        <div className="product-panel">
          <p className="panel-label">Choose Product</p>
          <h2>{productName}</h2>

          {!uploadImage && !persisted?.productImage ? (
            <div className="no-product-selected">
              <p>Please select a product from the home page to try on.</p>
            </div>
          ) : (
            <>
              <div className="product-panel-card">
                <img src={productImage} alt={productName} className="product-panel-image" />
                <div className="product-panel-info">
                  <h3>{productName}</h3>
                  <span className="upload-dress-badge">
                    <span className="upload-dress-checkmark">✓</span> Base item selected
                  </span>
                </div>
              </div>

              <div className="generate-btn-wrapper">
                <button
                  className="generate-btn-full"
                  disabled={!selectedImage || isGenerating || hasGenerated || trialBlocked}
                  onClick={handleGenerateTryOn}
                >
                  <span className={`sparkle-icon ${isGenerating ? 'spinning' : ''}`}>✨</span>
                  {hasGenerated ? 'Already Generated' : isGenerating ? 'Generating...' : 'Generate Try-On'}
                </button>
                {!hasGenerated && !trialBlocked && (
                  <div className="button-badge">{remainingTrials} trial left</div>
                )}
              </div>

              {!selectedImage && !hasGenerated && !trialBlocked && (
                <p className="generate-hint">Select your photo on the left to begin.</p>
              )}
            </>
          )}
        </div>

        {/* RIGHT: Try-On Result */}
        <div className="result-panel">
          <p className="panel-label">Your Try-On Look</p>

          <div className="result-preview-box">
            {errorMsg ? (
              <div className="result-error">
                <p className="result-error-text">⚠️ {errorMsg}</p>
              </div>
            ) : loading ? (
              <div className="result-loader">
                <div className="result-spinner"></div>
                <p className="result-loader-text">Generating your AI try-on...</p>
              </div>
            ) : showResult ? (
              <img src={resultImage} alt="AI Result" className="result-img" />
            ) : (
              <p className="preview-placeholder-text">Your try-on preview will appear here</p>
            )}
          </div>

          {showResult && !loading && (
            <>
              <div className="result-action-buttons">
                <button className="download-result-btn" onClick={handleDownloadResult}>
                  ⬇ Download
                </button>
                <button
                  className="save-result-btn"
                  onClick={handleSaveResult}
                  disabled={isSaving || isSaved}
                >
                  {isSaved ? '✓ Saved' : isSaving ? 'Saving...' : '🔖 Save'}
                </button>
              </div>
              <button className="view-product-btn" onClick={handleCancel}>
                View Product Detail
              </button>
              <div className="result-product-details">
                <p className="result-product-details-label">Product Details</p>
                <p className="result-product-details-text">{productName}</p>
              </div>
            </>
          )}
        </div>
      </div>

      <CustomerFeedback
        show={showFeedback}
        onClose={() => setShowFeedback(false)}
        featureType="tryOn"
        onSubmit={() => {
          setFeedbackRefreshKey((prev) => prev + 1);
          setShowFeedback(false);
        }}
      />

      <FeedbackReviews featureType="tryOn" refreshKey={feedbackRefreshKey} />
    </div>
  );
};

export default UploadScreen;